// Index files serve as entry points for importing and exporting functions and classes only. They should not contain any application logic or implementation details.

import home from './home';

function index() {
  home();
}

export default index;
